// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { defaultConfigReducer } from "features/config/types";
import "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/database";
import "firebase/database";

const firebaseConfig = defaultConfigReducer.base.FIREBASE_CONFIG as any;
export const firebaseApp = firebase.initializeApp(firebaseConfig);

export { firebase };
